import { render, staticRenderFns } from "./BtnExcel.vue?vue&type=template&id=5fde3654&"
import script from "./BtnExcel.vue?vue&type=script&lang=js&"
export * from "./BtnExcel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports